export function getOnboardingHubCardStyles(props) {
    const { theme } = props;
    const styles = {
        commandButton: (() => ({
            i: {
                color: theme.palette.neutralPrimary,
            },
        }))(),
    };
    return styles;
}
//# sourceMappingURL=OnBoardingHubCard.styles.js.map